import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';

export default function UserRouter() {
  return (
    <Routes>
      <Route index element={<BlogListPage />} />
      <Route path=":slug" element={<BlogDetailPage />} />
    </Routes>
  );
}
